import {
  FDBox,
  FDIcon, FDListItem, FDListItemAvatar, FDListItemSecondary, FDListItemText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React, { useState } from 'react';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxStrategyItemAdditionalInformationDialog,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/TaxSavingsSection/TaxStrategyItemAdditionalInformationDialog';

export const TaxStrategyItem = ({
  itemResource,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <FDBox {...dataAttrs('tax-strategy-item')}>
      <FDListItem onClick={() => setDialogOpen(true)}>
        {itemResource.isTruthy('hasNote') ? (
          itemResource?.withRelationship(
            fr.relationships.plannerProfileImage.name,
            (rel) => (
              <FDListItemAvatar
                src={rel.link('related').url()}
                alt={rel.meta('altText')}
              />
            ),
            () => null,
          )
        ) : null}
        <FDListItemText primaryText={itemResource.attr('name')} />
        <FDListItemSecondary>
          <FDIcon color={itemResource.attr('iconColor')} icon={itemResource.attr('icon')} />
        </FDListItemSecondary>
      </FDListItem>
      <TaxStrategyItemAdditionalInformationDialog itemResource={itemResource} setOpen={setDialogOpen} open={dialogOpen} />
    </FDBox>
  );
};

TaxStrategyItem.propTypes = {
  itemResource: PropTypes.instanceOf(fr.Resource).isRequired,
};
